<div class="row page-header">
    <div class="col-12">
        <h1>Users <small>Configure the users who have access to the system</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <div class="row action-toolbar">
        <div class="col-12">
            <form class="form-inline">
                <action-toolbar-count [grid]="grid"></action-toolbar-count>
                <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                <action-toolbar-buttons [grid]="grid" [canEdit]="canEdit" [showEdit]="true" [showDelete]="false"></action-toolbar-buttons>
                <button class="btn btn-sm btn-secondary" (click)="resetWebAppsUser()" [disabled]="!grid.hasItemSelected">
                    Reset WebApps User
                </button>
                <button
                    class="btn btn-sm btn-secondary"
                    (click)="setRequireMfa(true)"
                    [disabled]="!canEdit || !grid.hasItemSelected || grid.selectedItem?.isLessor"
                >
                    Require MFA
                </button>
                <button class="btn btn-sm btn-secondary" (click)="setRequireMfa(false)" [disabled]="!canEdit || !grid.hasItemSelected">
                    Stop requiring MFA
                </button>
                <button class="btn btn-sm btn-secondary" (click)="requireMfaForHighRisk()" [disabled]="!canEdit">
                    Require MFA for high-risk
                </button>
                <button class="btn btn-sm btn-secondary" (click)="resetMfa()" [disabled]="!canEdit || !grid.hasItemSelected">
                    Reset MFA
                </button>
                <button
                    class="btn btn-sm btn-secondary"
                    style="margin-left: auto"
                    (click)="deleteUser()"
                    [disabled]="!grid.hasItemSelected"
                >
                    <fa-icon class="d-none d-sm-inline-block" [icon]="faXmark"></fa-icon> Delete User
                </button>
            </form>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <wj-flex-grid
                id="mainGrid"
                #mainGrid
                appAutoSize
                (initialized)="grid.initialize(mainGrid)"
                (destroy)="grid.destroy()"
                [itemsSource]="grid.view"
            >
                <wj-flex-grid-filter></wj-flex-grid-filter>
                <wj-flex-grid-column [header]="'Active'" [binding]="'active'" [width]="85"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Vista Active'" [binding]="'isVistaActive'" [width]="90"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Lessor'" [binding]="'isLessor'" [width]="90"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'High-Risk'" [binding]="'isHighRisk'" [width]="90"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'MFA Required'" [binding]="'requireAuthenticatorMfa'" [width]="110"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'MFA Enrolled'" [binding]="'twoFactorEnabled'" [width]="110"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Sign In'" [binding]="'name'" [width]="85" [format]="'d'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'HrRef'" [binding]="'hrRef'" [width]="85" [format]="'d'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Vendor #'" [binding]="'vendorId'" [width]="95" [format]="'d'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Name'" [binding]="'displayName'" [width]="225"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Email'" [binding]="'emailAddress'" [width]="250"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Position Code'" [binding]="'positionCode'" [width]="125"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Job Title'" [binding]="'jobTitle'" [width]="250"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Image'" [binding]="'image'" [width]="175"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Roles'" [binding]="'roleNames'" [minWidth]="250" [width]="'*'">
                    <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                        <div [title]="cell.item.roleNames">
                            {{ cell.item.roleNames }}
                        </div>
                    </ng-template>
                </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Additional Rights'" [binding]="'extraRightsNames'" [minWidth]="1000" [width]="'*'">
                    <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                        <div [title]="cell.item.extraRightsNames">
                            {{ cell.item.extraRightsNames }}
                        </div>
                    </ng-template>
                </wj-flex-grid-column>
            </wj-flex-grid>
        </div>
    </div>
</div>
